import React from 'react';
import Fade from 'react-reveal/Fade';

import {
	BoxWrapper,
	EvaluationCriteriaWrapper,
} from './evaluationCriteria.styled';
import Container from '../container/container.component';

interface Props {
	className?: string;
	criteria?: any;
}

const EvaluationCriteriaComponent = (props: Props) => {
	const { className, criteria } = props;

	return (
		<EvaluationCriteriaWrapper className={className ? className : ''}>
			<Container>
				<Fade top cascade>
					<div className="content">
						<p className="title">Evaluation Criteria</p>
						<div className="boxes">
							{criteria?.length > 0 &&
								criteria.map((item: string, index: number) => {
									return (
										<BoxWrapper key={index} index={index}>
											<p
												dangerouslySetInnerHTML={{
													__html: item,
												}}
											></p>
										</BoxWrapper>
									);
								})}
						</div>
					</div>
				</Fade>
			</Container>
		</EvaluationCriteriaWrapper>
	);
};

export default EvaluationCriteriaComponent;
